<template>
  <div class="generic_picker">
    <van-cell
      value-class="custom_cell__value"
      :title="title"
      :value="selected"
      is-link
      @click="onShow"
    />

    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        :default-index="defaultIndex"
        :columns="columns"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Cell, Picker, Popup } from 'vant'

export default {
  name: 'GenericPicker',
  model: {
    prop: 'value',
    event: 'confirm'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    }
  },
  components: {
    [Cell.name]: Cell,
    [Picker.name]: Picker,
    [Popup.name]: Popup
  },
  data () {
    return {
      show: false,
      defaultIndex: 0,
      selected: ''
    }
  },
  created () {
    this.selected = this.value
  },
  methods: {
    onShow () {
      this.show = true
    },
    onConfirm (value, index) {
      this.selected = value
      this.$emit('confirm', value)
      this.show = false
    },
    onCancel () {
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
